import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { WizardComponent } from 'angular-archwizard';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @ViewChild('closeBTN') closeBTN: ElementRef;
  @ViewChild('confirmSwalPlainte') private confirmSwalPlainte: SwalComponent;
  @ViewChild('confirmSwal') private confirmSwal: SwalComponent;
  @ViewChild('confirmSwalLetter') private confirmSwalLetter: SwalComponent;
  @ViewChild('wizard', {static: false}) wizard: WizardComponent;
  sendMessage = 0;
  emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  formSinistre: FormGroup;
  firstClick: boolean = false;
  loader: boolean = false;
  listSinistre: any = [];
  tabFiles:any =[];
  hasPhoneError:boolean;
  isFocus: unknown;
  currentPays = "Senegal";
  slideData = [
    {
      title: "Inclusive Market",
      subTitle: "Toutes vos assurances en 1 seul endroit",
      description: "Votre devis gratuit personnalisé en un seul clic",
      img: "assets/images/bannieres-1.png",
      btnText: "En savoir plus",
      btnUrl: "/services"
    },
    {
      title: "Votre assurance automobile",
      subTitle: "",
      description: "Votre devis gratuit personnalisé en un seul clic",
      img: "assets/images/slide-automobile.png",
      btnText: "En savoir plus",
      btnUrl: "/services"
    },
    {
      title: "Votre assurance multirisque",
      subTitle: "",
      description: "Votre devis gratuit personnalisé en un seul clic",
      img: "assets/images/slide-habitation.png",
      btnText: "En savoir plus",
      btnUrl: "/services"
    },
    {
      title: "Votre assurance sante",
      subTitle: "",
      description: "Votre devis gratuit personnalisé en un seul clic",
      img: "assets/images/slide-sante.png",
      btnText: "En savoir plus",
      btnUrl: "/services"
    },
    {
      title: "Votre assurance Vie",
      subTitle: "",
      description: "Votre devis gratuit personnalisé en un seul clic",
      img: "assets/images/slide-vie.jpg",
      btnText: "En savoir plus",
      btnUrl: "/services"
    },
    {
      title: "Votre assurance voyage",
      subTitle: "",
      description: "Votre devis gratuit personnalisé en un seul clic",
      img: "assets/images/slide-voyage.jpg",
      btnText: "En savoir plus",
      btnUrl: "/services"
    }

  ];
  besoins = [

    {
      title: "Vie",
      img: "assets/images/vie.jpg",
      subImg: "assets/images/vie.svg",
      btnText: "Demander un devis",
      btnUrl: "/prevoyance-deces"
    },
    {
      title: "Multirisque",
      img: "assets/images/pro.jpg",
      subImg: "assets/images/pro.svg",
      btnText: "Demander un devis",
      btnUrl: "/multirisque-pro"
    },
    {
      title: "Auto",
      img: "assets/images/auto.jpg",
      subImg: "assets/images/auto.svg",
      btnText: "Demander un devis",
      btnUrl: "/auto-mono"
    },
    {
      title: "Voyage",
      img: "assets/images/voyage.jpg",
      subImg: "assets/images/voyage.svg",
      btnText: "Demander un devis",
      btnUrl: "/voyage"
    },
    {
      title: "Santé",
      img: "assets/images/sante.jpg",
      subImg: "assets/images/sante.svg",
      btnText: "Demander un devis",
      btnUrl: "/sante"
    },
    {
      title: "Stock de marchandises",
      img: "assets/images/marchandises.jpg",
      subImg: "assets/images/marchandises.svg",
      btnText: "Demander un devis",
      btnUrl: "/stock-marchandises"
    }
  ]
  avantages = [
    {
      title: "Suivi portefeuille",
      img: "assets/images/suivi.jpg",
      subImg: "assets/images/portefeuille.svg",
      btnText: "Demander un devis",
      btnUrl: "porte"
    },
    {
      title: "Audit de portefeuille",
      img: "assets/images/portefeuille.jpg",
      subImg: "assets/images/loupe.svg",
      btnText: "Demander un devis",
      btnUrl: "porte"
    },
    {
      title: "formation (gratuite)",
      img: "assets/images/formation.jpg",
      subImg: "assets/images/formation.svg",
      btnText: "Demander un devis",
      btnUrl: "formation"
    }
  ]
  relations = [
    {
      title: "Relation personnalisée <br> avec nos clients",
      img: "assets/images/relation.svg",
      class: "client"
    },
    {
      title: "Tarif en ligne <br> immédiat",
      img: "assets/images/tarif.svg",
      class: "tarif"
    },
    {
      title: "vos besoins couvert <br> à 360°",
      img: "assets/images/360.svg",
      class: "tarif"
    }
  ]
  employeurData = [
    {
      img: "assets/images/case-studies-1.png",
      title: "Création de compte",
      description: "Demande de création d'un compte d'accès à votre espace privé employeur. La création de compte est gratuit et ne prends pas plus 2 minutes. Vous devez fournir juste les informations nécessaires pour procéder à la création du compte.",
      icon: "folder"
    },
    {
      img: "assets/images/case-studies-2.png",
      title: "Consultation de compte",
      description: "Les cotisations sont assises sur la rémunération brute des intéressés jusqu’à concurrence d’un plafond fixé chaque année par le Conseil d’Administration. L’assiette de cotisation représente toutes sommes versées ou dues au travailleur ou à l’occasion d’un travail",
      icon: "eye"
    },
    {
      img: "assets/images/case-studies-3.png",
      title: "Demande attestation en ligne",
      description: "Demandez une attestion ",
      icon: "file-pdf"
    },
    {
      img: "assets/images/case-studies-4.png",
      title: "Paiement cotisations en ligne",
      description: "Payez vos cotisations",
      icon: "credit-card"
    },
    {
      img: "assets/images/case-studies-5.png",
      title: "Formalités d’Immatriculation",
      description: "Demandez une Immatriculation",
      icon: "window-restore"
    },
    {
      img: "assets/images/case-studies-6.png",
      title: "Déclaration nominative des rémunérations en ligne",
      description: "Déclaration des rémunérations",
      icon: "book"
    },
  ];
  temoignages = [
    {
      img: "assets/images/temoignage-1.png",
      nom: "Mme Aminata Diouf, ",
      poste: "CEO SIFF",
      description: "Explications trés clair surtout Mme Deffa fort sympatique. Je recommande pour les futurs.",
      icon: "assets/images/etoile.PNG"
    },
    {
      img: "assets/images/temoignage-2.png",
      nom: "M. Assane Ndiaye, ",
      poste: "DG vitruva",
      description: "Explications trés clair surtout Mme Deffa fort sympatique. Je recommande pour les futurs.",
      icon: "assets/images/etoile.PNG"
    },
    {
      img: "assets/images/temoignage-3.png",
      nom: "M. Assane Ndiaye, ",
      poste: "DG vitruva",
      description: "Explications trés clair surtout Mme Deffa fort sympatique. Je recommande pour les futurs.",
      icon: "assets/images/etoile.PNG"
    }
  ];
  partenaires = [

    {
      img: "assets/images/01.jpg",
    },
    // {
    //   img: "assets/images/02.png",
    // },
    // {
    //   img: "assets/images/03.png",
    // },
    // {
    //   img: "assets/images/00.png",
    // },
    {
      img: "assets/images/04.jpg",
    },
    // {
    //   img: "assets/images/05.png",
    // },
    {
      img: "assets/images/06.jpg",
    },
    {
      img: "assets/images/07.jpg",
    },
    {
      img: "assets/images/08.jpg",
    },
    // {
    //   img: "assets/images/09.png",
    // },
    // {
    //   img: "assets/images/10.png",
    // },
    {
      img: "assets/images/11.jpg",
    },
    // {
    //   img: "assets/images/12.png",
    // },
    {
      img: "assets/images/13.jpg",
    },
    // {
    //   img: "assets/images/14.png",
    // },
    {
      img: "assets/images/15.jpg",
    },
    // {
    //   img: "assets/images/16.png",
    // }
  ];
  fileName = "";
  email="";
  validEmail :boolean =true;
  safariClass="";
  formPlainte: FormGroup;
  sinistreForm: FormGroup;
  fieldsPlainte = [{
    label: "Nom",
    field: "nom",
    icon: "assets/images/nom.svg",
    type: "text",
    isRequired: true,
    class: '',
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Prénom",
    field: "prenom",
    icon: "assets/images/nom.svg",
    type: "text",
    isRequired: true,
    class: '',
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Email",
    field: "email",
    icon: "assets/images/icon-email.svg",
    type: "email",
    isRequired: true,
    class: '',
    validations: [{ name: "pattern", value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: "Ce champ est invalide" }]
  }, {
    label: "Numéro de téléphone",
    field: "telephone",
    icon: "assets/images/icon-telephone.svg",
    type: "tel",
    isRequired: true,
    class: '',
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Prestataire du réseau de soin",
    field: "prestataire",
    icon: "assets/images/icon-personne-morale.svg",
    type: "text",
    isRequired: true,
    class: '',
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  },
  {
    label: "Entreprise",
    field: "entreprise",
    icon: "assets/images/icon-personne-morale.svg",
    type: "text",
    class: '',
    isRequired: true,
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  },
  {
    label: "Type plainte",
    field: "type",
    icon: "assets/images/icon-carte-grise.svg",
    type: "select",
    isRequired: true,
    class: '',
    list: [{ name: 'Mauvais accueil', value: 'Mauvais accueil' }, { name: "Ne travaille plus avec l'assureur", value: "Ne travaille plus avec l'assureur" }, { name: 'Problème Informatique', value: 'Problème Informatique' }, { name: "Retard Prise en charge", value: "Retard Prise en charge" }, { name: "Autres", value: "Autres" }],
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Nature plainte",
    field: "autres",
    icon: "assets/images/icon-carte-grise.svg",
    type: "text",
    chieldOther: { name: 'type', value: 5 },
    isRequired: false,
    class: '',
    validations: []
  }, {
    label: "Autres précisions",
    field: "description",
    icon: "assets/images/icon-carte-grise.svg",
    type: "textarea",
    isRequired: false,
    class: '',
    validations: []
  }, {
    label: "Date de l'incident",
    field: "dateIncident",
    icon: "assets/images/icon-date.svg",
    type: "date",
    isRequired: true,
    class: '',
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }];
  newDate = new Date();
  maxDateNaissance = new Date()
  step : number = 0;
  maxStep : number = 8;
  titleButton: string = "C’est parti !!";
  loaderVisible: boolean = false;
  data;
  listesAssureurs = [];
  listesModels = [];
  listesMarque = [];
  listTypeSinistre = [
    { name: 'DECES', value: 'DECES' },
    { name: 'INVALIDITE', value: 'INVALIDITE' },
  ];
  constructor(private toastr: ToastrService,private authService: AuthService,private subscriptionService:SubscriptionService,) {
       // Safari 3.0+ "[object HTMLElementConstructor]"
      //  var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
          this.safariClass="";
        } else {
          this.safariClass="isSafari";
        }
      }
      const before18years: any = moment().subtract(18, 'years');
      this.maxDateNaissance = new Date(before18years);
      
  }

  ngOnInit(): void {
    this.initForm();
    // this.getListeSinistre();
    // this.getModels();
    // this.getAssureur();
    localStorage.setItem('sectionShown','accueil');
  }

  marque() {
    this.subscriptionService.getmodel(this.sinistreForm.get('marque').value).subscribe((resp) => {
      if (resp['responseCode'] == 200) {
        this.listesModels = resp['data'];
      }
    });
  }

  getAssureur() {
    this.authService.getAssureurs().subscribe(resp => {
      if (resp['responseCode'] == 200) {
        this.listesAssureurs = resp['data'];
      }
    });
  }

  getModels() {
    this.subscriptionService.getModel().subscribe(resp => {
      if (resp['responseCode'] == 200) {
        this.listesMarque = resp['data'];
      }
    });
  }

  precStep(){
    this.step--;
  }

  cancel(){
    this.step = 0;
    this.sinistreForm.reset();
    this.data = null;
    this.listesAssureurs = [];
    this.listesModels = [];
    this.listesMarque = [];
  }
  change(){
    if (this.sinistreForm.get('tiers').value == 'oui' && this.sinistreForm.get('typeAssurance').value == 'AUTO') {
      this.maxStep = 11;
    }else if (this.sinistreForm.get('typeAssurance').value == 'AUTO') {
      this.maxStep = 9;
    }else {
      this.maxStep = 8;
    }
  }
  nextStep(){
    if(this.step == 1){
      if (this.sinistreForm.get('numeroPolice').value != '' && this.sinistreForm.get('numeroPolice').value != null) {
        this.loaderVisible = true;
        this.subscriptionService.getContrat(this.sinistreForm.get('numeroPolice').value).subscribe(resp => {
          if (resp['responseCode'] == 200) {
            this.loaderVisible = false;
            this.step++;
            this.data = resp['data'];
            this.sinistreForm.get('typeAssurance').setValue(this.data['typeRisque']);
            if (this.data['typeRisque'] == 'AUTO') {
              this.maxStep = 9;
            }else {
              this.maxStep = 8;
            }
          } else {
            this.loaderVisible = false;
            this.toastr.error('Erreur sur le serveur', 'Attention !!!');
          }
        }, error => {
          this.loaderVisible = false;
          this.toastr.error('Impossible de contacter le serveur', 'Erreur !!!');
        });
      }else {
        this.toastr.error('Veuillez renseigner le numéro de contrat', 'Erreur !!!');
      }
    }else {
      this.step++;
    }
    if(this.step > 0){
      this.titleButton = "Continuer";
    }
  }

  soumettre() {
    this.confirmSwal.fire();
  }

  initForm() {
    this.formSinistre = new FormGroup({
      nom: new FormControl('', [Validators.required]),
      prenom: new FormControl('', [Validators.required]),
      telephone: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])]),
      adresse: new FormControl('', [Validators.required]),
      type: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      fileSinistre:new FormControl(''),
      autre:new FormControl('')
    });
    this.formPlainte = new FormGroup({
      nom: new FormControl('', [Validators.required]),
      prenom: new FormControl('', [Validators.required]),
      telephone: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])]),
      prestataire: new FormControl('', [Validators.required]),
      type: new FormControl('', [Validators.required]),
      entreprise: new FormControl('', [Validators.required]),
      description:new FormControl(''),
      dateIncident:new FormControl(new Date(),Validators.required),
      autres:new FormControl('')
    });
    this.sinistreForm = new FormGroup({
      typeAssurance: new FormControl("", [Validators.required]),
      prenomDeclarant: new FormControl("", [Validators.required]),
      nomDeclarant: new FormControl("", [Validators.required]),
      dateNaissance: new FormControl(""),
      lieuNaissance: new FormControl(""),
      sexe: new FormControl(""),
      typeDePiece: new FormControl(""),
      numeroDePiece: new FormControl(""),
      dateDexpiration: new FormControl(""),
      adresseDeclarant: new FormControl(""),
      telephoneDeclarant: new FormControl("", [Validators.required]),
      email: new FormControl("", [Validators.pattern(this.emailPattern)]),
      profession: new FormControl(""),
      numImmat: new FormControl("",[Validators.required]),
      utilvehicul: new FormControl("", [Validators.required]),
      dateVisitetechnik: new FormControl("", [Validators.required]),
      numeroPolice: new FormControl("",[Validators.required]),
      typePolice: new FormControl("INTERNE",[Validators.required]),
      numeroSinistre: new FormControl("",[Validators.required]),
      typeSinistre: new FormControl(null),
      dateSinistre: new FormControl(""),
      details: new FormControl(""),
      domat: new FormControl("", [Validators.required]),
      declaration: new FormControl(""),
      domcorporel: new FormControl("", [Validators.required]),
      declarationCorporel: new FormControl(""),
      dateAccident: new FormControl("",[Validators.required]),
      lieuAccident: new FormControl("",[Validators.required]),
      circonstance: new FormControl("",[Validators.required]),
      tiers: new FormControl("", [Validators.required]),
      nomPropr: new FormControl(""),
      nomConduc: new FormControl(""),
      compagnie: new FormControl(""),
      marque: new FormControl(""),
      modele: new FormControl(""),
      immatProp: new FormControl(""),
      autreMarque: new FormControl(""),
      autreModel: new FormControl(""),
      indempnisation: new FormControl(""),
      prevention: new FormControl(""),
    })
  }

  suivant(){
    this.wizard.goToNextStep();
    this.getModels();
    this.getAssureur();
  }

  annuler(){
    this.wizard.goToStep(0);
    this.sinistreForm.reset();
  }

  precedent(){
    this.wizard.goToPreviousStep();
  }

  checkContrat(){
    if(this.sinistreForm.get('numeroPolice').value){
      this.loaderVisible = true;
      this.subscriptionService.getContrat(this.sinistreForm.get('numeroPolice').value).subscribe(resp => {
        if (resp['responseCode'] == 200) {
          this.loaderVisible = false;
          this.wizard.goToNextStep();
          this.data = resp['data'];
          this.sinistreForm.get('typeAssurance').setValue(this.data['typeRisque']);
        } else {
          this.loaderVisible = false;
          this.toastr.error('Erreur sur le serveur', 'Attention !!!');
        }
      }, error => {
        this.loaderVisible = false;
        this.toastr.error('Impossible de contacter le serveur', 'Erreur !!!');
      });
    }else {
      this.toastr.error('Veuillez renseigner le numéro de contrat', 'Erreur !!!');
    }
  }
  savePlainte() {
    this.loader = true;
    let value = this.formPlainte.value;
    // if(this.formPlainte.get('autres').value!=''){
    //   this.formPlainte.get('type').setValue(this.formPlainte.get('autres').value);
    // }
    value['date'] = new Date();
    value["pays"] = this.currentPays,
      this.authService.savePlainte(value).subscribe(resp => {
        if (resp['responseCode'] == 200) {
          this.loader = false;
          this.toastr.success('Plainte envoyée avec succès', 'Succès');
          this.closeBTN.nativeElement.click();
        } else {
          this.loader = false;
          this.toastr.error('Erreur sur le serveur', 'Attention !!!');
        }
      }, error => {
        this.loader = false;
        this.toastr.error('Impossible de contacter le serveur', 'Erreur !!!');
      });

  }

  checkDate(evt, formcontrol, form) {
    if (evt == 'Invalid Date')
      this[form].get(formcontrol).setValue('');
    else if (evt != null && evt != '') {
      this[form].get(formcontrol).setValue(evt);
    }

  }

  getFile(evt){
    let file = evt.target.files;
    if(evt.target.files && evt.target.files[0]){
      if(file.length!=0){
        this.fileName="";
        this.tabFiles = [];
        for(let fichier of file){
          this.fileName =this.fileName+" " +fichier.name;
          this.tabFiles.push({nom:'Sinistre',file:fichier});
        }
      }
    }
  }
  checkFormPlainte() {
    if (this.formPlainte.invalid || this.hasPhoneError) {
      this.checkValidity(this.formPlainte);
    } else {
      this.firstClick = false;
      this.confirmSwalPlainte.fire();
    }
  }
  checkValidity(g: FormGroup) {
    Object.keys(g.controls).forEach(key => {
      g.get(key).markAsDirty();
    });
    Object.keys(g.controls).forEach(key => {
      g.get(key).markAsTouched();
    });
    Object.keys(g.controls).forEach(key => {
      g.get(key).updateValueAndValidity();
    });
  }
  getListeSinistre() {
    this.authService.getSinistre().subscribe(resp => {
      this.listSinistre = resp['data'];
    });
  }
  ngAfterViewInit(): void{
    this.slideData = [
      {
        title: "Inclusive Market",
        subTitle: "Toutes vos assurances en 1 seul endroit",
        description: "Votre devis gratuit personnalisé en un seul clic",
        img: "assets/images/bannieres-1.png",
        btnText: "En savoir plus",
        btnUrl: "/services"
      },
      {
        title: "Votre assurance automobile",
        subTitle: "",
        description: "Votre devis gratuit personnalisé en un seul clic",
        img: "assets/images/slide-automobile.png",
        btnText: "En savoir plus",
        btnUrl: "/services"
      },
      {
        title: "Votre assurance multirisque",
        subTitle: "",
        description: "Votre devis gratuit personnalisé en un seul clic",
        img: "assets/images/slide-habitation.png",
        btnText: "En savoir plus",
        btnUrl: "/services"
      },
      {
        title: "Votre assurance sante",
        subTitle: "",
        description: "Votre devis gratuit personnalisé en un seul clic",
        img: "assets/images/slide-sante.png",
        btnText: "En savoir plus",
        btnUrl: "/services"
      },
      {
        title: "Votre assurance Vie",
        subTitle: "",
        description: "Votre devis gratuit personnalisé en un seul clic",
        img: "assets/images/slide-vie.jpg",
        btnText: "En savoir plus",
        btnUrl: "/services"
      },
      {
        title: "Votre assurance voyage",
        subTitle: "",
        description: "Votre devis gratuit personnalisé en un seul clic",
        img: "assets/images/slide-voyage.jpg",
        btnText: "En savoir plus",
        btnUrl: "/services"
      }

    ];
  }
  validateEmail() {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.email)) {
        this.validEmail = false;
      } else {
        this.validEmail = true;
        this.confirmSwalLetter.fire();
      }
  }
  scroolDiv(el:HTMLElement){
    el.scrollIntoView();
  }
  saveLetters(){
    this.loader=true;
    let data = {
      email:this.email
    };
    this.authService.saveLetter({'contains':JSON.stringify(data)}).subscribe(resp=>{
      if(resp['responseCode']==200){
        this.loader=false;
        this.email ="";
        this.toastr.success('Souscription éffectuée avec succès', 'Succès');
      }else{
        this.loader=false;
        this.toastr.error('Erreur sur le serveur', 'Attention !!!');
      }
    },error=>{
      this.loader=false;
      this.toastr.error('Erreur sur le serveur', 'Veuillez réessayer');
    });
  }

  enregisterSinistre(){
    let value = {
      'lieu': this.sinistreForm.get('lieuAccident').value,
      'date': this.sinistreForm.get('dateAccident').value,
      'description': this.sinistreForm.get('circonstance').value,
      "designationClient":this.sinistreForm.get('prenomDeclarant').value +' '+ this.sinistreForm.get('nomDeclarant').value,
      "telephone":this.sinistreForm.get('telephoneDeclarant').value,
      "email":this.sinistreForm.get('email').value,
      "adresse":this.sinistreForm.get('adresseDeclarant').value,
      "numeroPolice":this.sinistreForm.get('numeroPolice').value,
      "typePolice": this.sinistreForm.get('typePolice').value,
      "numeroSinistre":this.sinistreForm.get('numeroSinistre').value ? this.sinistreForm.get('numeroSinistre').value : '',
      'content': JSON.stringify(this.sinistreForm.value),
    }
    this.loaderVisible = true;
    this.subscriptionService.sinitreDeclaration(value).subscribe((resp) => {
      if (resp['responseCode'] == 200) {
        this.loaderVisible = false;
        this.toastr.success('Sinistre enregistré avec succès', 'Succès');
        this.wizard.goToStep(0);
        this.sinistreForm.reset();
      } else {
        this.loaderVisible = false;
        this.toastr.error('Erreur lors de l\'enregistrement du sinistre', 'Erreur');
      }
    })
  }

  saveSinistre() {
    this.loader = true;
    let value=this.formSinistre.value;
    value['pays']=this.currentPays;
    this.authService.saveSinistre(value).subscribe(resp => {
      if (resp['responseCode'] == 200) {
        let i=0;
        if(this.tabFiles.length!=0){
          for(let files of this.tabFiles){
            let dataFiles =new FormData();
            dataFiles.append('sinistre',resp['data']['id']);
            dataFiles.append('nom',files.nom);
            dataFiles.append('files',files.file);
            this.authService.saveFile(dataFiles).subscribe(val=>{
              i++;
            });
          }
        }
          this.loader = false;
          this.sendMessage = 1;
          this.fileName="";
          setTimeout(() => {
            this.sendMessage = 0;
            this.initForm();
          }, 10000);
          this.formSinistre.reset();
        // }
      } else {
        this.sendMessage = 2;
        this.loader = false;
        setTimeout(() => {
          this.sendMessage = 0;
        }, 10000);
      }
    }, error => {
      this.sendMessage = 2;
      this.loader = false;
      setTimeout(() => {
        this.sendMessage = 0;
      }, 10000);
    });

  }
  checkForm() {
    if(this.formSinistre.invalid || this.hasPhoneError){
      this.firstClick=true;
    }else{
      this.firstClick=false;
      this.confirmSwal.fire();
    }
  }

  hasError(ev,field,form) {
    this.hasPhoneError = !ev ? true : false;
    let currentValue = this[form].get(field).value;
    if (this.currentPays == 'Côte d’Ivoire' && this.hasPhoneError) {
      if (currentValue != '') {
        if (currentValue.includes("+225") && currentValue.length != 14) {
          this.hasPhoneError = true;
          let val = currentValue.replace('+225', '');
          this[form].get(field).setValue(val);
        } else if (currentValue.length == 10 && !currentValue.includes("+225")) {
          this.hasPhoneError = false;
          let value = '+225' + currentValue;
          this[form].get(field).setValue(value);
        } else if (currentValue.includes("+225") && currentValue.length == 14) {
          let val = currentValue.replace('+225', '');
          this[form].get(field).setValue(val);
          this.hasPhoneError = false;
        }
      }
    } else if (this.currentPays == 'Côte d’Ivoire' && !this.hasPhoneError){
      let val = currentValue.replace('+225', '');
      this[form].get(field).setValue(val);
      this.hasPhoneError = true;
    }
  }

  getNumber(ev, field, form) {
    if(this.currentPays!='Côte d’Ivoire')
      this[form].get(field).setValue(ev);
  }
  onCountryChange(ev) {
    let value = ev['name'].toString();
    let val = "";
    for (let i = 0; i < value.length; i++) {
      if (value[i] == '(') {
        val = value.substring(0, i - 1);
        this.currentPays = val;

      } else {
        this.currentPays = value;
      }
    }

  }
  telInputObject(ev) {
  }

  getRoute(route) {
    localStorage.setItem('route', route);
  }
}
